import { useMemo } from 'react'
import { useMailboxSentAnalytics, MailboxSentData } from './useMailboxSentAnalytics'

export interface ClientMailboxSentFilter {
  clientName: string
  timePeriod: 'today' | 'yesterday' | 'last_7_days' | 'last_14_days' | 'last_30_days'
}

export function useClientMailboxSentAnalytics(filter?: ClientMailboxSentFilter) {
  const { data: allSentData = [], isLoading, refetch } = useMailboxSentAnalytics()

  const filteredData = useMemo(() => {
    if (!filter) return allSentData

    return allSentData.filter(mailbox => {
      // Filter by client name
      const matchesClient = mailbox.client_name === filter.clientName
      
      // Filter by time period - only show mailboxes that have sent emails in the selected period
      let hasSentInPeriod = false
      switch (filter.timePeriod) {
        case 'today':
          hasSentInPeriod = mailbox.sent_today > 0
          break
        case 'yesterday':
          // For yesterday, we need sent emails in the last 2 days but not today
          hasSentInPeriod = mailbox.sent_7d > mailbox.sent_today && mailbox.sent_today === 0
          break
        case 'last_7_days':
          hasSentInPeriod = mailbox.sent_7d > 0
          break
        case 'last_14_days':
          hasSentInPeriod = mailbox.sent_14d > 0
          break
        case 'last_30_days':
          hasSentInPeriod = mailbox.total_sent > 0
          break
      }

      return matchesClient && hasSentInPeriod
    })
  }, [allSentData, filter])

  return {
    data: filteredData,
    isLoading,
    refetch
  }
}